<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Primary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (primaryValveSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Package Size:</label>
            <select class="halfWidthInputField" #primaryValveSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryValveSizeSelection.Name)"
              (change)="selectionChanged(primaryValveSizeSelection, primaryValveSizeInput.value)"
              [value]="primaryValveSizeSelection.Value.toString()">
              @for (allowable of primaryValveSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryValveSizeSelection.Value && primaryValveSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryStrainerSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Strainer:</label>
            <select class="halfWidthInputField" #primaryStrainerInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryStrainerSelection.Name)"
              (change)="selectionChanged(primaryStrainerSelection, primaryStrainerInput.value)"
              [value]="primaryStrainerSelection.Value.toString()">
              @for (allowable of primaryStrainerSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryStrainerSelection.Value && primaryStrainerSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (primaryControlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #primaryControlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryControlValveSelection.Name)"
              (change)="selectionChanged(primaryControlValveSelection, primaryControlValveInput.value)"
              [value]="primaryControlValveSelection.Value.toString()">
              @for (allowable of primaryControlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryControlValveSelection.Value && primaryControlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryFlowControlSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select class="halfWidthInputField" #primaryFlowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryFlowControlSelection.Name)"
              (change)="selectionChanged(primaryFlowControlSelection, primaryFlowControlInput.value)"
              [value]="primaryFlowControlSelection.Value.toString()">
              @for (allowable of primaryFlowControlSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryFlowControlSelection.Value && primaryFlowControlSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (primaryIsolationBallValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select class="halfWidthInputField" #primaryIsolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryIsolationBallValveSelection.Name)"
              (change)="selectionChanged(primaryIsolationBallValveSelection, primaryIsolationBallValveInput.value)"
              [value]="primaryIsolationBallValveSelection.Value.toString()">
              @for (allowable of primaryIsolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryIsolationBallValveSelection.Value && primaryIsolationBallValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryIsolationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Hose Kit:</label>
            <select class="halfWidthInputField" #primaryIsolationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryIsolationSelection.Name)"
              (change)="selectionChanged(primaryIsolationSelection, primaryIsolationInput.value)"
              [value]="primaryIsolationSelection.Value.toString()">
              @for (allowable of primaryIsolationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryIsolationSelection.Value && primaryIsolationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (primaryServiceFittingSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Service Fittings:</label>
            <select class="halfWidthInputField" #primaryServiceFittingsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryServiceFittingSelection.Name)"
              (change)="selectionChanged(primaryServiceFittingSelection, primaryServiceFittingsInput.value)"
              [value]="primaryServiceFittingSelection.Value.toString()">
              @for (allowable of primaryServiceFittingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryServiceFittingSelection.Value && primaryServiceFittingSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryNormallyOpenSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(primaryNormallyOpenSelection.Name)"
            for="primaryNormallyOpenInput" class="halfWidthInputLabel">Normally Open:</label>
            <input type="checkbox" class="checkboxInput" id="primaryNormallyOpenInput"
              #primaryNormallyOpenInput [checked]="'true' === primaryNormallyOpenSelection.Value"
              (change)="selectionChanged(primaryNormallyOpenSelection, primaryNormallyOpenInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (primaryBalanceOnBypassSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(primaryBalanceOnBypassSelection.Name)"
            for="primaryBalanceOnBypassInput" class="halfWidthInputLabel">Balance on Bypass:</label>
            <input type="checkbox" class="checkboxInput" id="primaryBalanceOnBypassInput"
              #primaryBalanceOnBypassInput [checked]="'true' === primaryBalanceOnBypassSelection.Value"
              (change)="selectionChanged(primaryBalanceOnBypassSelection, primaryBalanceOnBypassInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
